import { ClusterCommunityDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadClusterCommunity = createAction(
  '[ClusterCommunity] Load ClusterCommunity'
);

export const loadClusterCommunitySuccess = createAction(
  '[ClusterCommunity] Load ClusterCommunity Success',
  props<{ clusterCommunity: ClusterCommunityDto[] }>()
);

export const loadClusterCommunityFailure = createAction(
  '[ClusterCommunity] Load ClusterCommunity Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addClusterCommunity = createAction(
  '[ClusterCommunity] Add ClusterCommunity',
  props<{ newClusterCommunity: ClusterCommunityDto[] }>()
);

export const addClusterCommunitySuccess = createAction(
  '[ClusterCommunity] Add ClusterCommunity Success',
  props<{ newClusterCommunity: ClusterCommunityDto[] }>()
);

export const addClusterCommunityFailure = createAction(
  '[ClusterCommunity] Add ClusterCommunity Failure',
  props<{ error: any }>()
);

/**
 * Update ClusterCommunity Collection Actions
 */
export const updateClusterCommunity = createAction(
  '[ClusterCommunity] Update ClusterCommunity',
  props<{ updateClusterCommunity: ClusterCommunityDto[] }>()
);

export const updateClusterCommunitySuccess = createAction(
  '[ClusterCommunity] Update ClusterCommunity Success',
  props<{ updateClusterCommunity: ClusterCommunityDto[] }>()
);

export const updateClusterCommunityFailure = createAction(
  '[ClusterCommunity] Update ClusterCommunity Failure',
  props<{ error: any }>()
);

/**
 * Remove ClusterCommunity Collection Actions
 */
export const removeClusterCommunity = createAction(
  '[ClusterCommunity] Remove ClusterCommunity',
  props<{ ids: string[] }>()
);

export const removeClusterCommunitySuccess = createAction(
  '[ClusterCommunity] Remove ClusterCommunity Success',
  props<{ ids: string[] }>()
);

export const removeClusterCommunityFailure = createAction(
  '[ClusterCommunity] Remove ClusterCommunity Failure',
  props<{ error: any }>()
);
